import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27230 27873"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:403.954;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315925584">
        <path
          d="M1451 820h24465"
          className="fill-none stroke1"
          style={{
            strokeWidth: 403.954,
            strokeLinejoin: "round",
          }}
        />
        <ellipse cx={758} cy={869}           className="fill-none stroke1"
          style={{
            strokeWidth: 403.954,
            strokeLinejoin: "round",
          }}
 rx={556} ry={568} />
        <ellipse cx={26472} cy={820}           className="fill-none stroke1"
          style={{
            strokeWidth: 403.954,
            strokeLinejoin: "round",
          }}
 rx={556} ry={618} />
        <path
          d="M21290 15044c-2482-1876-5844-5244-6631-11086M25446 27603V942M25446 27671c-692 0-692-135-1384-135s-692 135-1383 135c-693 0-693-135-1386-135-694 0-694 135-1389 135-694 0-2180-68-2180-68l3150-10807M25446 16217l-5008 376v-1549l5008 265zM5964 15044c2447-1849 5749-5149 6596-10838M1809 27603V942M1809 27671c692 0 692-135 1384-135 691 0 691 135 1383 135 693 0 693-135 1386-135 694 0 694 135 1388 135s2180-68 2180-68L6380 16796M1809 16365l5007 228v-1549l-4894 363z"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 403.954,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M25446 4327c-621 0-621-459-1243-459-621 0-621 459-1242 459s-621-459-1242-459-621 459-1243 459c-621 0-621-459-1243-459s-622 459-1243 459c-622 0-622-459-1244-459-621 0-621 459-1243 459s-622-459-1244-459c-621 0-621 459-1241 459-621 0-621-459-1241-459-623 0-623 459-1245 459-621 0-621-459-1243-459s-622 459-1245 459-623-459-1246-459c-622 0-622 459-1244 459-623 0-623-459-1247-459-625 0-625 459-1249 459-625 0-625-459-1249-459"
                    className="fill-none stroke1"
          style={{
            strokeWidth: 403.954,
            strokeLinejoin: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
